/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type { ErrorType } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type {
	GetUmbracoDeliveryApiV2SiteSettingsParams,
	IApiContentResponseModel,
} from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getUmbracoDeliveryApiV2SiteSettings = (
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<IApiContentResponseModel>(
		{
			url: `/umbraco/delivery/api/v2/site-settings`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetUmbracoDeliveryApiV2SiteSettingsQueryKey = (
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
) => {
	return [
		`/umbraco/delivery/api/v2/site-settings`,
		...(params ? [params] : []),
	] as const;
};

export const getGetUmbracoDeliveryApiV2SiteSettingsQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoDeliveryApiV2SiteSettingsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2SiteSettings(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2SiteSettingsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>
>;
export type GetUmbracoDeliveryApiV2SiteSettingsQueryError = ErrorType<void>;

export function useGetUmbracoDeliveryApiV2SiteSettings<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2SiteSettingsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SiteSettings<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SiteSettings<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2SiteSettings<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetUmbracoDeliveryApiV2SiteSettingsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoDeliveryApiV2SiteSettingsSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoDeliveryApiV2SiteSettingsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2SiteSettings(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2SiteSettingsSuspenseQueryResult =
	NonNullable<Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>>;
export type GetUmbracoDeliveryApiV2SiteSettingsSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2SiteSettingsSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2SiteSettingsParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SiteSettingsSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SiteSettingsSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2SiteSettingsSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SiteSettingsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2SiteSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2SiteSettingsSuspenseQueryOptions(params, options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}
